import styled from "styled-components";

const TM_BLUE = "#0c4982";
const TM_GREEN = "rgb(110,250,160)";
const TWITCH_PURPLE = "#9047ff";
const getBackground = (tag: string) => {
  switch (tag) {
    case "APAC":
      return "palegreen";
    case "EU":
      return "deepskyblue";
    case "Mapping":
      return "lightcyan";
    case "MEA":
      return "moccasin";
    case "NCSA":
      return "lightcoral";
    case "Official":
      return TM_BLUE;
    case "Resource":
    case "Tracker":
    case "Tools":
      return "thistle";
    case "Streamer":
      return "lavender";
    case "Team":
      return "mistyrose";
    case "TM2020":
      return TM_GREEN;
    default:
      return "whitesmoke";
  }
};

const getForeground = (tag: string) => {
  switch (tag) {
    case "APAC":
      return "darkgreen";
    case "EU":
      return "mediumblue";
    case "Mapping":
      return "dodgerblue";
    case "MEA":
      return "chocolate";
    case "NCSA":
      return "maroon";
    case "Official":
      return TM_GREEN;
    case "Resource":
    case "Tracker":
    case "Tools":
      return "indigo";
    case "Streamer":
      return TWITCH_PURPLE;
    case "Team":
      return "firebrick";
    case "TM2020":
      return TM_BLUE;
    default:
      return "dimgray";
  }
};

export const Pill = styled.div<{ tag: string }>`
  min-width: 20px;
  text-align: center;
  border-radius: 6px;
  padding: 1px 4px;
  font-size: 9pt;
  background: ${({ tag }) => getBackground(tag)};
  border: ${({ tag }) => `1px solid ${getForeground(tag)}`};
  color: ${({ tag }) => getForeground(tag)};
`;
